import { apiRequest } from './client';
// Invite a person into a TC group via ControlPlane: raises (or re-sends) an emailed
// invitation they must accept. Nobody is added to the group here, and the answer is the
// same whether or not the address already has an account. Routes to the control-plane
// base because '/identity' is a control-plane prefix (see resolveApiBase).
export async function provisionTcGroupMember(payload) {
    await apiRequest('POST', '/identity/provision', payload);
}
// The group's invitations that have not been accepted yet (group admins only).
export async function getTcGroupInvitations(region, groupId) {
    const params = new URLSearchParams({ region, groupId });
    return apiRequest('GET', `/identity/group-invitations?${params}`);
}
// Returns the subset of the given identity ids that are pending (never-activated
// invites). Activation status lives on ControlPlane, not the regional DB.
export async function getPendingMemberIds(ids) {
    if (ids.length === 0)
        return [];
    const result = await apiRequest('POST', '/identity/pending-status', {
        ids,
    });
    return result.pendingIds;
}
// Revokes a pending invite into one group: a not-yet-accepted invitation, or a
// never-activated member (removes that membership; the person is deleted outright only
// when nothing else on the platform still uses them).
export async function revokePendingMember(payload) {
    await apiRequest('POST', '/identity/revoke-pending', payload);
}
